import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {PagingResolverService} from '@abstract/paging-resolver.service';
import {TechnicalDeviceDocumentsPagesService} from './technical-device-documents-pages.service';

/**
 * Получение данных по документации ТУ
 */
@Injectable()
export class TechnicalDeviceDocumentsResolver extends PagingResolverService {
    constructor(
        service: TechnicalDeviceDocumentsPagesService,
        router: Router,
    ) {
        super(service, router);
    }

    resolve(snapshot: ActivatedRouteSnapshot) {
        const service = this.resolverService as TechnicalDeviceDocumentsPagesService;

        const id = +snapshot.parent.params.id;

        service.resetParams();

        service.deviceId = id;

        return super.resolve(snapshot);
    }
}
